import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { TextContainer } from '../components';
import { getTextPaginate } from '../features/text/textSlice';

const Draft = () => {
  const dispatch = useDispatch();
  const { account, chainId } = useSelector((store) => store.user);

  useEffect(() => {
    dispatch(getTextPaginate());
  }, [account, chainId, dispatch]);

  return <TextContainer />;
};

export default Draft;
